import {
  AppPlatform_iOS_getInstancen6zsnixoh3w2 as AppPlatform_iOS_getInstance,
  AppPlatform_Android_getInstanceoi5cw4duvk8g as AppPlatform_Android_getInstance,
  AppPlatform_Web_getInstance10fsaay04fbhg as AppPlatform_Web_getInstance,
  AppPlatform_Desktop_getInstancewuln9i6vat0d as AppPlatform_Desktop_getInstance,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toAppPlatform(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.ordinal_1) {
    case 0:
      tmp = AppPlatform_iOS_getInstance();
      break;
    case 1:
      tmp = AppPlatform_Android_getInstance();
      break;
    case 2:
      tmp = AppPlatform_Web_getInstance();
      break;
    case 3:
      tmp = AppPlatform_Desktop_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
//region block: exports
export {
  toAppPlatform as toAppPlatform36bnn01mmf21b,
};
//endregion

//# sourceMappingURL=Platform.ext.mjs.map
